import React from "react";
import { CheckCircle, RefreshCw, ShieldCheck } from "lucide-react";

const TrustSection = () => {
  const features = [
    {
      id: 1,
      icon: <CheckCircle className="w-8 h-8 text-[#D4AF37]" />,
      title: "100% Certified",
      subtitle: "Highest purity and authenticity standards, certified by global grading agencies."
    },
    {
      id: 2,
      icon: <RefreshCw className="w-8 h-8 text-[#D4AF37]" />,
      title: "Lifetime Exchange",
      subtitle: "Lifetime exchange value across any collection and any time, guaranteed."
    },
    {
      id: 3,
      icon: <ShieldCheck className="w-8 h-8 text-[#D4AF37]" />,
      title: "Secured Shipping",
      subtitle: "Fully insured and secured shipping from door-to-door, without exceptions."
    }
  ];

  return (
    <div className="w-full bg-[#1A110A] py-16 md:py-20 relative text-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <h2 className="text-3xl md:text-4xl font-serif text-white mb-3">
          Why Customers Trust <span className="text-[#D4AF37]">Hire Panna</span>
        </h2>
        <p className="text-gray-400 text-sm md:text-base tracking-widest uppercase mb-12">
          The combination that makes us stand out
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
          {features.map((feature) => (
             <div key={feature.id} className="flex flex-col items-center">
               <div className="w-16 h-16 rounded-full border border-dashed border-[#D4AF37] flex items-center justify-center mb-6">
                 {feature.icon}
               </div>
               <h3 className="text-white text-lg font-serif mb-3 tracking-wide">
                 {feature.title}
               </h3>
               <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
                 {feature.subtitle}
               </p>
             </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustSection;
